<template>
  <div>
    <v-layout
      wrap
      justify-center
      pb-10
      pt-0
      pt-xs-0
      pt-sm-0
      pt-md-16
      pt-lg-16
      pt-xl-16
      px-0
      px-xs-0
      px-sm-0
      px-md-1-
      px-lg-10
      px-xl-10
    >
      <v-flex xs12 align-self-center>
        <v-carousel
          v-model="slideNo"
          :interval="slideInterval"
          hide-delimiter-background
          delimiter-icon="mdi-minus"
          :height="sliderHeight"
        >
          <v-carousel-item v-for="(item, i) in items" :key="i">
            <v-card flat class="hidden-sm-and-down">
              <v-img
                :lazy-src="item.image"
                :src="item.image"
                width="100%"
                contain
                :alt="item.image"
                eager
              >
                <v-layout
                  wrap
                  justify-start
                  pa-10
                  px-xs-0
                  px-sm-0
                  px-md-16
                  px-lg-16
                  px-xl-16
                  pt-8
                  fill-height
                >
                  <v-flex xs10 sm7 pl-6 align-self-center text-left>
                    <span
                      :style="{ color: item.colors }"
                      style="font-family: opensanssemibold; font-size: 25px"
                      >{{ item.text }}</span
                    >
                    <br />
                    <v-flex xs12 pt-5>
                      <v-btn
                        color="#30B868"
                        dark
                        rounded
                        width="135px"
                        elevation="0"
                        class="text-capitalize"
                        :to="'/ecoShop'"
                      >
                        <span style="font-family: opensansbold">Shop Now</span>
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
                <template v-slot:placeholder> <ImageLoader /> </template
              ></v-img>
            </v-card>
            <v-card flat class="hidden-md-and-up">
              <v-img :lazy-src="item.image" :src="item.image" eager>
                <v-layout
                  wrap
                  justify-start
                  pa-10
                  px-xs-0
                  px-sm-10
                  px-md-16
                  px-lg-16
                  px-xl-16
                  pt-8
                  fill-height
                >
                  <v-flex xs10 sm8 pl-6 align-self-center text-left>
                    <span
                      :style="{ color: item.colors }"
                      style="font-family: opensanssemibold; font-size: 15px"
                      >{{ item.text }}</span
                    >
                    <br />
                    <v-flex xs12 pt-5>
                      <v-btn
                        color="#30B868"
                        dark
                        small
                        rounded
                        width="100px"
                        elevation="0"
                        class="text-capitalize"
                        :to="'/ecoShop'"
                      >
                        <span style="font-family: opensansbold">Shop Now</span>
                      </v-btn>
                    </v-flex>
                  </v-flex>
                </v-layout>
                <template v-slot:placeholder> <ImageLoader /> </template
              ></v-img>
            </v-card>
          </v-carousel-item>
        </v-carousel>
        <v-card flat>
          <v-layout wrap justify-center pa-5 px-16 px-xs-16 px-sm-16 px-md-5 px-lg-16 px-xl-16>
            <v-flex
              xs12
              sm6
              md3
              pt-2
              pt-xs-2
              pt-sm-0
              pt-md-0
              pt-lg-0
              pt-xl-0
              text-left
              v-for="(subitem, s) in subItems"
              :key="s"
            >
              <v-layout wrap justify-center>
                <v-flex xs2 sm2 align-self-center>
                  <v-img :src="subitem.img" width="35px" height="35px"></v-img>
                </v-flex>
                <v-flex xs10 sm10>
                  <span
                    style="
                      font-family: opensanssemibold;
                      text-transform: uppercase;
                    "
                  >
                    {{ subitem.title }}
                  </span>
                  <br />
                  <span style="font-family: opensansregular; font-size: 15px">
                    {{ subitem.text }}
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
import axios from "axios";
export default {
  data: () => ({
    model: 0,
    tab: 0,
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    menu: false,
    prog: "",
    newProg: "",
    caraouselitems: [],
    caroselText: [],
    items: [
      {
        image: require("./../../assets/carousel1.jpg"),
        text: "Embrace the Purity of Nature. Choose Sustainable Products for a Healthier Lifestyle.",
        color: "#121535",
      },
      {
        image: require("./../../assets/carousel2.jpg"),
        text: "Discover the Purity and Potency of Natural Products. Choose Sustainability for a Healthier World",
        color: "white",
      },
    ],
    subItems: [
      {
        img: require("./../../assets/icons/fast.png"),
        title: "Fast Delivery",
        text: "Quick, reliable service.",
      },
      {
        img: require("./../../assets/icons/easy.png"),
        title: "Easy Shopping",
        text: "Quick, convenient checkout.",
      },
      {
        img: require("./../../assets/icons/vast.png"),
        title: "Vast Selection",
        text: "All products in one place.",
      },
      {
        img: require("./../../assets/icons/secure.png"),
        title: "Secure Payments",
        text: "Safe and trusted payment options.",
      },
    ],
  }),
  computed: {
    sliderHeight() {
      var height = "300px";
      if (this.$vuetify.breakpoint.xl) height = "100%";
      if (this.$vuetify.breakpoint.lg) height = "100%";
      if (this.$vuetify.breakpoint.md) height = "250px";
      if (this.$vuetify.breakpoint.sm) height = "180px";
      if (this.$vuetify.breakpoint.xs) height = "190px";
      return height;
    },
  },
  beforeMount() {
    // this.getCarousel();
  },
  methods: {
    getCarousel() {
      axios({
        method: "GET",
        url: "/carosel",
      })
        .then((response) => {
          this.caraouselitems = response.data.caroselImage;
          this.caroselText = response.data.caroselText;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  <style>
.theme--light.v-tabs-items {
  background-color: transparent !important;
  background: transparent linear-gradient(180deg, #000000 0%, #54545450 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
}

.btn-border {
  border: 2px solid #30d5c8;
}

.boom {
  background-color: #fff;
  z-index: 2px;
}

.clash {
  z-index: 1px;
  /* padding-bottom: 250px; */
  position: relative;
}

.Headd {
  position: relative;
}

.Taill {
  position: absolute;
  top: 650px;
  z-index: 3;
  right: 0;
  left: 0;
  display: grid;
}

.under {
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: -1;
}

.over {
  position: absolute;
  left: 40px;
  top: 10px;
  z-index: -1;
}

@media only screen and (min-device-width: 360px) and (max-device-width: 900px) {
  .hig {
    top: 640px !important;
  }
}

@media only screen and (min-device-width: 900px) and (max-device-width: 960px) {
  .hig {
    top: 640px !important;
  }
}

@media only screen and (min-device-width: 960px) and (max-device-width: 1200px) {
  .hig {
    top: 600px !important;
  }
}

@media only screen and (min-device-width: 1200px) and (max-device-width: 1300px) {
  .hig {
    top: 600px !important;
  }
}

@media only screen and (min-device-width: 1300px) and (max-device-width: 1400px) {
  .hig {
    top: 1300px !important;
  }
}

@media only screen and (min-device-width: 1400px) and (max-device-width: 1500px) {
  .hig {
    top: 1280px !important;
  }
}

@media only screen and (min-device-width: 1500px) and (max-device-width: 1800px) {
  .hig {
    top: 1280px !important;
  }
}

@media only screen and (min-device-width: 1800px) and (max-device-width: 2000px) {
  .hig {
    top: 1280px !important;
  }
}

@media only screen and (min-device-width: 2000px) and (max-device-width: 3000px) {
  .hig {
    top: 1280px !important;
  }
}

@media only screen and (min-device-width: 3000px) and (max-device-width: 6000px) {
  .hig {
    top: 1280px !important;
  }
}
</style>
  